/**
 * Smooth Scroll when click on link
 * @dependencies jump.js
 * @dependencies ez.js
 */
/**
 * Smooth Scroll when click on link
 */
import Jump from 'jump.js'
import { easeInOutCubic } from 'ez.js';

const links = document.getElementsByClassName('js-smooth-scroll');
for (let index = 0; index < links.length; index++) {
  const el = links[index];
  const url = el.getAttribute('href');
  const hash = url.substring(url.indexOf('#') + 1);
  const duration = el.getAttribute('data-jump-duration') ? el.getAttribute('data-jump-duration') : 800;

  el.addEventListener('click', (ev) => {
    ev.preventDefault();
    const headerHeight = document.querySelector('.js-fixed-header').offsetHeight;

    Jump(`#${hash}`, {
      duration: duration,
      offset: -headerHeight,
      easing: easeInOutCubic
    })
  })
}

// Specific to ressources page to get anchor to filters on load (coming from home links)
window.addEventListener('load', function(event) {
  const url_string = (window.location.href).toLowerCase();
  const url = new URL(url_string);
  const ressources_types = url.searchParams.get("_ressources_types");
  const headerHeight = document.querySelector('.js-fixed-header').offsetHeight;

  if(!ressources_types) {
    return;
  } else {
    Jump('.search-filters', {
      duration: 1000,
      offset: -headerHeight,
      easing: easeInOutCubic
    })
  }
});
